const translations = {
	subtitle: "Oups ! La page que vous cherchez semble introuvable.",
	button: "Retour à l'accueil",
};

export default translations;
